import { defineStore } from 'pinia'
import { useRootStore } from '@/stores/root'
import moment from 'moment'

import http from '@/services/http'

export const useCustomersStore = defineStore('customers', {
  actions: {
  async fetchCustomersList({ searchText, loader = true, forceRefresh }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers',
        params: searchText ? { txtric: searchText } : null,
      }, forceRefresh);
      if (loader) useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      if (loader) useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getLastCustomer() {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/last',
      });
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async fetchCustomer({ customerId, loader = true, forceRefresh }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerId}/info`,
      }, forceRefresh);
      if (loader) useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      if (loader) useRootStore().setIsLoading(false);
      return false;
    }
  },
  async fetchCustomerAddresses(customerId) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerId}/addresslist`,
      });
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerDocuments({ customerId, date = 'null', forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerId}/documents`,
        params: { mmaaaa: date },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerSales({ customerId, date = 'null', forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerId}/sold-products`,
        params: { anndoc: date },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerContacts({ customerId, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerId}/list-contacts`,
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async createCustomerContact({
    title,
    fullname,
    departmentCode,
    phone,
    mobile,
    email,
    notes,
    newsletter,
  }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'post',
        path: '/customers/contacts',
        data: {
          anacod: useRootStore().lastCustomer.anacod,
          anatip: 1,
          titolo: title,
          codrep: departmentCode,
          numtel: phone,
          numcel: mobile,
          nomcon: fullname,
          iemail: email,
          notcon: notes,
          stacir: newsletter === true ? 'S' : 'N',
        },
      });
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async updateCustomerContact({
    contactId,
    title,
    fullname,
    departmentCode,
    phone,
    mobile,
    email,
    notes,
    newsletter,
  }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'put',
        path: `/customers/${useRootStore().lastCustomer.anacod}/contacts/`,
        data: {
          codcon: contactId,
          anacod: useRootStore().lastCustomer.anacod,
          anatip: 1,
          titolo: title,
          codrep: departmentCode,
          numtel: phone,
          numcel: mobile,
          nomcon: fullname,
          iemail: email,
          notcon: notes,
          stacir: newsletter === true ? 'S' : 'N',
        },
      });
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async deleteCustomerContact({ contactId }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'delete',
        path: `/customers/${useRootStore().lastCustomer.anacod}/delete/`,
        data: {
          anatip: 1,
          codcon: contactId,
        },
      });
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerOpenedDocuments({ customerId, documentType, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerId}/documents/open`,
        params: {
          tipdoc: documentType,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerDocumentTypes() {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/typedocuments',
      });
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerExpirations({ customerId, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerId}/expirations`,
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerDataRevenue({
    customerId, date = 'null', forceRefresh, loader,
  }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerId}/revenue`,
        params: { anndoc: date },
      }, forceRefresh);
      return response;
    } catch (err) {
      throw err;
    } finally {
      if (loader) useRootStore().setIsLoading(false);
    }
  },
  async customerDataCredit({ customerId, forceRefresh, loader }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerId}/credit`,
      }, forceRefresh);
      return response;
    } catch (err) {
      throw err;
    } finally {
      if (loader) useRootStore().setIsLoading(false);
    }
  },
  async customerDataLastDocuments({ customerId, forceRefresh, loader }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerId}/lastdocs`,
      }, forceRefresh);
      return response;
    } catch (err) {
      throw err;
    } finally {
      if (loader) useRootStore().setIsLoading(false);
    }
  },
  async customerDataInfos({ customerId, forceRefresh, loader }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerId}/brandinfo`,
      }, forceRefresh);
      return response;
    } catch (err) {
      throw err;
    } finally {
      if (loader) useRootStore().setIsLoading(false);
    }
  },
  async customerSuggestedProducts({
    customerId,
    anndoc,
    cart,
    forceRefresh,
  }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/products/suggested',
        params: Object.assign(
          {
            codcli: customerId,
            codmag: useRootStore().user?.profile.codiceMagazzino,
            year: anndoc,
          },
          cart && { numpro: cart },
        ),
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerPaymentsType({ customerId, forceRefresh }) {
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerId}/paymentType`,

      }, forceRefresh);
      useRootStore().setIsLoading(false);
    
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerDocumentCreation({
    documentType,
    documentSubtype,
    reference,
    deliveryDate,
    addressCode,
    documentId,
    warehouseCode,
    paymentType,
    forceRefresh,
  }) {
    useRootStore().setIsLoading(true);
    try {
      console.log('create',   documentType,
    documentSubtype,
    reference,
    deliveryDate,
    addressCode,
    documentId,
    warehouseCode,
    paymentType,)
      const response = await http.request({
        method: 'post',
        path: '/documents/create',
        data: Object.assign(
          {
            anacod: useRootStore().lastCustomer.anacod,
          },
          documentSubtype && { coddoc: documentSubtype },
          documentType && { doctype: documentType },
          deliveryDate && { datcon: deliveryDate },
          reference && { numrif: reference },
          addressCode && { codind: addressCode },
          // if documentId, this endpoints change the current document
          documentId && { numpro: documentId },
          warehouseCode && { codmag: warehouseCode },
          paymentType && { codpag: paymentType }
        ),
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerDocumentClose({
    documentId,
    totalProcessing,
    addressCode,
    vector,
    delivery,
    documentType,
    documentSubType,
    notes,
    deliveryMode,
    forceRefresh,
  }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'post',
        path: `/documents/${documentId}/close`,
        data: {
          evatot: totalProcessing ? 'S' : 'N',
          modspe: delivery,
          codvet: vector,
          codpor: deliveryMode,
          codind: addressCode,
          tipdse: documentType,
          coddse: documentSubType,
          txtnot: notes,
          coddoc: useRootStore().user?.profile.coddoc,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerDocumentLineAdd({
    documentId,
    articleCode,
    quantity,
    rowType,
    discount1,
    discount2,
    discount3,
    discount4,
    price,
    description,
    notes,
    rowLine,
    deliveryDate,
    forceRefresh,
  }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'post',
        path: `/documents/${documentId}/createline`,
        data: Object.assign(
          {
            numpro: documentId,
            numrig: rowLine || 0,
            codart: articleCode || '',
            qta: quantity,
            datcon: deliveryDate,
            scont1: discount1 || 0,
            scont2: discount2 || 0,
            scont3: discount3 || 0,
            scont4: discount4 || 0,
            prezzo: price || 0,
          },
          rowType && { tipmov: rowType },
          description && { desart: description },
          notes && { txtnot: notes },
        ),
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerDocumentLineAddCheck({
    documentId,
    articleCode,
    quantity,
    rowType,
    discount1,
    discount2,
    discount3,
    discount4,
    price,
    description,
    notes,
    rowLine,
    deliveryDate,
    forceRefresh,
  }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'post',
        path: `/documents/${documentId}/documentCreateLineCheck`,
        data: Object.assign(
          {
            numpro: documentId,
            numrig: rowLine || 0,
            codart: articleCode || '',
            qta: quantity,
            datcon: deliveryDate,
            scont1: discount1 || 0,
            scont2: discount2 || 0,
            scont3: discount3 || 0,
            scont4: discount4 || 0,
            prezzo: price || 0,
          },
          rowType && { tipmov: rowType },
          description && { desart: description },
          notes && { txtnot: notes },
        ),
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerDocumentLineRemove({
    documentId,
    line,
    forceRefresh,
  }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/documents/${documentId}/removeline?numrig=${line}`,
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerDocumentRemove({
    documentId,
    forceRefresh,
  }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/documents/${documentId}/removeline?dltall=S?numrig=`,
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async updateCustomerCart({ documentId, loader = true, forceRefresh }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const [cart] = await http.request({
        method: 'get',
        path: `/documents/${documentId}/total`,
      }, forceRefresh);
      useRootStore().setCart({
        count: cart.totrig,
        value: cart.valtot,
        documentId: cart.numpro,
      });
      if (loader) useRootStore().setIsLoading(false);
    } catch (err) {
      if (loader) useRootStore().setIsLoading(false);
      throw err;
    }
  },
  async customerValuation({ customerId, forceRefresh, loader }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerId}/valuation`,
      }, forceRefresh);
      return response;
    } catch (err) {
      throw err;
    } finally {
      if (loader) useRootStore().setIsLoading(false);
    }
  },
  async customerRelations({
    customerId, dateFrom, dateTo, forceRefresh, loader,
  }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/getActivityCustomer',
        params: {
          anacod: customerId,
          data01: dateFrom && moment(dateFrom).format('YYYY-MM-DD'),
          data02: dateTo && moment(dateTo).format('YYYY-MM-DD'),
        },
      }, forceRefresh);
      return response;
    } catch (err) {
      throw err;
    } finally {
      if (loader) useRootStore().setIsLoading(false);
    }
  },
  async createPotentialCustomer({
    businessName,
    secondBusinessName,
    street,
    zipCode,
    location,
    province,
    vatNumber,
    fiscalCode,
    category,
    contact,
    email,
    telephoneNumber,
    notes,
  }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'post',
        path: '/customers/insertPotentialCustomer',
        data: {
          ragsoc: businessName,
          ragso2: secondBusinessName,
          indiri: street,
          cap: zipCode,
          locali: location,
          provin: province,
          numtel: telephoneNumber,
          percon: contact,
          email,
          catcl1: category,
          note: notes,
          pariva: vatNumber,
          codfis: fiscalCode,
        },
      });
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async updatePotentialCustomer({
    businessName,
    secondBusinessName,
    street,
    zipCode,
    location,
    province,
    vatNumber,
    fiscalCode,
    category,
    contact,
    email,
    telephoneNumber,
    notes,
    customerId,
  }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'post',
        path: '/customers/insertPotentialCustomer',
        data: {
          ragsoc: businessName,
          ragso2: secondBusinessName,
          indiri: street,
          cap: zipCode,
          locali: location,
          provin: province,
          numtel: telephoneNumber,
          percon: contact,
          email,
          catcl1: category,
          note: notes,
          pariva: vatNumber,
          codfis: fiscalCode,
          anacod: customerId,
        },
      });
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async fetchPotentialCustomers({ customerCode, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/getPotentialCustomer',
        params: {
          anacod: customerCode,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getCustomersCategories({ forceRefresh } = {}) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/categories',
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getCustomersBackorder({ codfil = null, loader = true, forceRefresh } = {}) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/customersBackorder',
        params: {
          codfil
        }
      }, forceRefresh);
      if (loader) useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      if (loader) useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getTotalBackorderRetiredBill({ codfil = null, loader = true, forceRefresh } = {}) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/getTotalBackorderRetiredBill',
        params: {
          codfil
        }
      }, forceRefresh);
      if (loader) useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      if (loader) useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getCustomerMedia({ customerCode, forceRefresh } = {}) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerCode}/customerMedia`,
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getCustomerNote({ customerId, tipNot = 'I', forceRefresh } = {}) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${customerId}/customerNote`,
        params: {
          tipnot: tipNot,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerSalesDetail({
    productCode, customerId, year, loader = true, forceRefresh,
  } = {}) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/salesDetail',
        params: {
          codart: productCode,
          anacod: customerId,
          anno: year,
        },
      }, forceRefresh);
      if (loader) useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      if (loader) useRootStore().setIsLoading(false);
      return false;
    }
  },
  async customerDailyTurnover({ customerCode, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/dailyTurnover',
        params: {
          anacod: customerCode,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  insertRelationAttachment({ code }) {
    return http.request({
      method: 'post',
      path: '/products/insertmedia',
      data: {
        keydoc: code,
        tiprec: 'REL',
        anacod: useRootStore().lastCustomer.anacod,
      },
    });
  },
  getRelationMedia({ keydoc, forceRefresh }) {
    return http.request({
      method: 'get',
      path: '/products/media',
      params: {
        tiprec: 'rel',
        codart: keydoc,
      },
    }, forceRefresh);
  },
  async getAgentsCustomer({ forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/getAgentsCustomer',
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getWarehousesCustomer({ forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/getWarehousesCustomer',
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getDiscountList({ customerId, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/getDiscountList',
        params: {
          codcli: customerId,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getCustomerBudget({ customerId, yearFilter, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/getCustomerBudget',
        params: {
          customerId,
          anndoc: yearFilter,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getDestinationList({ forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/getDestinationList',
        params: {
          customerId: useRootStore().lastCustomer.anacod,
          anatip: '1',
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getTicketsCashed({ customer, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/getTicketsCashed',
        params: {
          customerId: customer,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async updateCustomerDestination({
    businessName,
    destinationCode,
    address,
    postalCode,
    locality,
    province,
  }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'post',
        path: '/customers/insertDestination',
        data: {
          customerId: useRootStore().lastCustomer.anacod,
          ragsoc: businessName,
          codind: destinationCode, // if empty create, else update
          indiri: address,
          cap: postalCode,
          locali: locality,
          provin: province,
        },
      });
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async deleteCustomerDestination({ customerId, destinationCode }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'post',
        path: '/customers/deleteDestination',
        data: {
          anatip: 1,
          customerId,
          codind: destinationCode,
        },
      });
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async checkVatNumber({ vatNumber, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/checkPariva',
        params: {
          anatip: '1',
          pariva: vatNumber,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async exportExpiredOrdersXls({ payload }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'post',
        path: '/customers/getOrdersExpiredListExcel',
        responseType: 'blob',
        data: payload,
      });
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getUserListSendingReports({ proto }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/UserListSendingReports',
        params: { numpro: proto },
      }, true);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async sendingReportToUser({ proto, user, userToSend }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/sendingReportToUser',
        params: {
          numpro: proto,
          codusr: user,
          users: userToSend,
          numrec: '1',
        },
      }, true);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async checkReport({ proto, user }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/checkReport',
        params: {
          numpro: proto,
          codusr: user,
        },
      }, true);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async sharedRelationshipsUser() {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/sharedRelationshipsUser',
      }, true);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async sendFileEmail({ fileName, file }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'post',
        path: '/customers/sendFileEmail',
        data: {
          file_name: fileName,
          file,
        },
      });
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getBonusList({ anacod, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${anacod}/bonusList`,
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getBonusManagement({ anacod, codbonus, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${anacod}/bonusManagement`,
        params: {
          codprm: codbonus,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getBonusBrackets({
      anacod,
      codbonus,
      codrow,
      forceRefresh,
    },
  ) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${anacod}/bonusBrackets`,
        params: {
          codprm: codbonus,
          codrig: codrow,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async consignmentPayment({
      anacod
    }

  ) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/customers/${anacod}/consignmentPayment`,
      }, true);

      // const response = [
      //   {
      //     numpro: "006261978",
      //     numrig: "0001",
      //     tipdoc: "BL",
      //     coddoc: "VIS",
      //     numdoc: "7777777",
      //     datdoc: "2025-11-18",
      //     datcon: "2025-11-18",
      //     numrif: "prova 1",
      //     locali: "MILANO",
      //     totres: 1000.00,
      //     valmer: 500.00,
      //     codmag: "02",
      //     blocco: "N",
      //     docnum: "VIS/7777777",
      //     codusr: "BLU035",
      //     desusr: "Laura Raimondi",
      //     blomod: "",
      //     codart: "72145965",
      //     codmar: "FER",
      //     artfor: "FDB925B",
      //     desart: "PADS",
      //     qtadoc: 1.000,
      //     datcns: "2025-11-18",
      //     valrig: 100.00,
      //     datcnf: "",
      //     flagco: "",
      //     flagbl: "",
      //     flagin: ""
      //   },
      //   {
      //     numpro: "006261978",
      //     numrig: "0002",
      //     tipdoc: "BL",
      //     coddoc: "VIS",
      //     numdoc: "7777777",
      //     datdoc: "2025-11-18",
      //     datcon: "2025-11-18",
      //     numrif: "prova 1",
      //     locali: "MILANO",
      //     totres: 1000.00,
      //     valmer: 500.00,
      //     codmag: "02",
      //     blocco: "N",
      //     docnum: "VIS/7777777",
      //     codusr: "BLU035",
      //     desusr: "Laura Raimondi",
      //     blomod: "",
      //     codart: "44189756",
      //     codmar: "FER",
      //     artfor: "FDB1349",
      //     desart: "PASTIGLIE FRENO",
      //     qtadoc: 2.000,
      //     datcns: "2025-11-18",
      //     valrig: 400.00,
      //     datcnf: "",
      //     flagco: "",
      //     flagbl: "",
      //     flagin: ""
      //   },
      //   {
      //     numpro: "006261979",
      //     numrig:"0001",
      //     tipdoc: "BL",
      //     coddoc: "VIS",
      //     numdoc: "8888888",
      //     datdoc: "2025-11-18",
      //     datcon: "2025-11-18",
      //     numrif: "prova 1",
      //     locali: "MILANO",
      //     totres: 5000.00,
      //     valmer: 2500.00,
      //     codmag: "02",
      //     blocco: "N",
      //     docnum: "VIS/8888888",
      //     codusr: "BLU035",
      //     desusr: "Laura Raimondi",
      //     blomod: "",
      //     codart: "18376749",
      //     codmar: "MOG",
      //     artfor: "FD-AX-0007",
      //     desart: "MOOG TIE RODS",
      //     qtadoc: 3.000,
      //     datcns: "2025-11-18",
      //     valrig: 900.00,
      //     datcnf: "",
      //     flagco: "",
      //     flagbl: "",
      //     flagin: ""
      //   },
      //   {
      //     numpro: "006261979",
      //      numrig:"0002",
      //     tipdoc: "BL",
      //     coddoc: "VIS",
      //     numdoc: "8888888",
      //     datdoc: "2025-11-18",
      //     datcon: "2025-11-18",
      //     numrif: "prova 1",
      //     locali: "MILANO",
      //     totres: 5000.00,
      //     valmer: 2500.00,
      //     codmag: "02",
      //     blocco: "N",
      //     docnum: "VIS/8888888",
      //     codusr: "BLU035",
      //     desusr: "Laura Raimondi",
      //     blomod: "",
      //     codart: "01233797",
      //     codmar: "RAI",
      //     artfor: "RA.0446.0E",
      //     desart: "P.ANT FIAT PUNTO -97LAN. Y -04 A. CON SE",
      //     qtadoc: 4.000,
      //     datcns: "2025-11-18",
      //     valrig: 1600.00,
      //     datcnf: "",
      //     flagco: "",
      //     flagbl: "",
      //     flagin: ""
      //   }
      // ];
      //console.log(items);
      useRootStore().setIsLoading(false);
      return response;

    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async saveConsignmentPayment({
      anacod,
      data
    }

  ) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'post',
        path: `/customers/${anacod}/saveConsignmentPayment`,
        data,
      }, true);

      return response;

    } catch (err) {
      return false;
    } finally {
      useRootStore().setIsLoading(false);
    }
  },
  },
})
